exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "electra-search, electra-search-results {\n  height: 100%;\n  position: absolute;\n  transform: translate3d(0, 0, 0);\n  width: 100%; }\n\nelectra-search-results {\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.5);\n  top: 100%;\n  transition: transform 0.25s ease; }\n\nelectra-search-results.hide {\n  transform: translate3d(0, calc(-100% - 5px), 0); }\n\n/* Desktop */\n:host.desktop electra-search-results {\n  left: 5px;\n  width: calc(100% - 10px); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/searchWrapper/searchWrapper.component.scss
// module id = 414
// module chunks = 1